<div id="collapse{{item}}" class="accordion-body collapse expanded_data">
    <div class="accordion-inner info_table">
       <div class="accordion" id="accordion41" *ngFor="let mainitem of VendorConsDocDropList;let mainindex=index;">
          <div class="accordion-group">
             <div class="accordion-heading">
                <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion41"
                   href="#Doc{{mainitem.SNO}}">
                   {{mainitem.DocCategory}} {{mainitem.emailLogId}}
                </a>
             </div>
             <div id="Doc{{mainitem.SNO}}" class="accordion-body collapse in">
                <div class="accordion-inner">
                   <div class="table_wrap">
                      <div class="custom_table_head">
                         <div class="custom_tr row">
                            <div class="custom_th colw-44">Document</div>
                            <div class="custom_th colw-14">View</div>
                            <div class="custom_th colw-14">Download</div>
                         </div>
                      </div>
                      <div class="custom_table_body">
                         <div class="custom_tr row" *ngFor="let item of mainitem.DocList;let currentindex=index;">
                            <div class="custom_td colw-44">
                              {{item.DocName}}
                            </div>
                            <div class="custom_td colw-14" data-tooltip="View Document" data-tooltip-location="bottom">
                               <span>
                                  <a href="#" target="_blank"><img
                                     src="../assets/images/icons/ic-doc-view.svg" alt="ic-doc-view" data-tooltip="View Document" data-tooltip-location="bottom" (click)="DownloadFile(item.UploadedFileName,'','0')"></a>
                               </span>
                            </div>
                            <div class="custom_td colw-14" data-tooltip="View Document" data-tooltip-location="bottom">
                               <span><img src="../assets/images/icons/ic-download-latest.svg" data-tooltip="View Document" data-tooltip-location="bottom"
                                     alt="ic-download-latest" (click)="DownloadFile(item.UploadedFileName,item.FileContent,'1')"></span>
                            </div>
                         </div>
                       
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
 </div>
